import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { CustomerDetailTypes } from '../..';

import { DynamicAssetWrapper } from './components/DynamicAssetWrapper';

export const Application: React.FC<CustomerDetailTypes.Props> = () => {
  return (
    <Box
      p={{ base: 0, sm: Spacing['inline.xxs'] }}
      bgColor={{ base: undefined, sm: Color['neutral.white'] }}
      borderRadius={BoxBorder.heavy}>
      <DynamicAssetWrapper />
    </Box>
  );
};
